import React, { useEffect, useState } from 'react';
import ExtendedButton from '@src/stories/elements/ExtendedButton/ExtendedButton';
import './ExtendedCollectionSubcollectionCTA.scss';
import {mobileBreakpoint} from "../../../../entrypoints/theme";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";


export default function ExtendedCollectionSubcollectionCTA ({ settings }) {
  const { 
    child_collections_links,
    subcollection_alignment_desktop, 
    subcollection_alignment_mobile,  
    subcollection_cta_padding_bottom_desktop, 
    subcollection_cta_padding_bottom_mobile, 
    subcollection_cta_padding_top_desktop, 
    subcollection_cta_padding_top_mobile, 
    subcollection_padding_left_right_mobile, 
    subcollection_padding_left_right_desktop,
    subcollection_content_button_style
  } = settings;

  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const padding_bottom = isMobile ? subcollection_cta_padding_bottom_mobile : subcollection_cta_padding_bottom_desktop;
  const padding_top = isMobile ? subcollection_cta_padding_top_mobile : subcollection_cta_padding_top_desktop;
  const padding_left_right = isMobile ? subcollection_padding_left_right_mobile : subcollection_padding_left_right_desktop;
  const subcollection_cta_padding = `${padding_top}px ${padding_left_right}px ${padding_bottom}px`;
  const subcollection_cta_alignment = isMobile ? subcollection_alignment_mobile : subcollection_alignment_desktop;
  const style: React.CSSProperties = {
    padding: subcollection_cta_padding || undefined,
    justifyContent: subcollection_cta_alignment || 'center',
  };

  return (
    child_collections_links && child_collections_links.length > 0 && (  
    <div className={`collection-subcollection-cta`} style={style}>
        { 
            child_collections_links.map((child, index) => (
                <div className='collection-subcollection-cta__block-cols' key={index}> 
                        <ExtendedButton
                            style={subcollection_content_button_style}
                            link={child.url}
                            label={child.title}
                          />
                </div>
          ))
        }
    </div>)
  );
}